import {useLocation, useNavigate, useParams} from "react-router-dom";
import DataTable from "react-data-table-component";
import React, { useState, useEffect } from 'react';
import { get } from "../../utils/fetchAPI";
import UserRoleForm from "../../components/user-role/userRoleForm";
import { toast } from "react-toastify";
import PageTitle from "../../components/page-title/pageTitle";
import { BiSolidUser } from "react-icons/bi";
import {IoArrowUndo} from "react-icons/io5";
import { FaEdit } from "react-icons/fa";


const UserDetails = ()=>{
    const { id } = useParams();  // Access user ID from URL
    const location = useLocation();
    const { state } = useLocation();
    const user = location.state?.user;
    const fromPage = state?.fromPage || 1;
    const navigate = useNavigate();

    console.log("User ID:", id);
    console.log("User data in user detail:", user);

    const [roles, setRoles] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [selectedRole, setSelectedRole] = useState(null);

    const closePopup = () => {
        setShowPopup(false);
        setSelectedRole(null);
    };

    useEffect(() => {
        fetchUserRole();
    }, []);

    const fetchUserRole = async () => {
        await get(`user-role/list/${ id }`)
            .then((response) => {
                const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
                console.log("role get", sortedData);
                setRoles(sortedData);
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });
    };

    const handleAddLocationSuccess = (isEdit) => {
        toast.success(isEdit ? "Role updated successfully!" : "Role added successfully!");
        fetchUserRole(); // Refresh the location list
        closePopup(); // Close the popup
    };

    const handleEditRole = (role) => {
        setSelectedRole(role);
        setShowPopup(true);
    };

    const columns = [
    {
        name: "Role Code",
        selector: (row) => row.role.code,
        sortable: true,
    },
    {
        name: "Status",
        selector: (row) => row.status,
        sortable: true,
    },
    {
        name: "Manufacturer Name",
        selector: (row) => row.manufacturerName,
        sortable: true,
    },
    {
        name: "Per Day Limit",
        selector: (row) => row.perDayLimit,
        sortable: true,
    },
    {
        name: "Fee",
        selector: (row) => row.fee,
        sortable: true,
    },
    {
        name: "Sponsor",
        selector: (row) => (row.sponsor ? "Yes" : "No"),
    },
    {
        name: "Medicine Priority",
        selector: (row) => (row.medicinePriority ? "Yes" : "No"),
    },
    {
        name: "Speciality",
        selector: (row) => row.specialty?.[0]?.display || "-",
        wrap: true,
    },
    {
        name: "Actions",
        cell: (row) => (
            <button
                className="p-1 bg-blue-500 text-white rounded hover:bg-blue-600"
                onClick={() => handleEditRole(row)}
                title="Edit"
            >
                <FaEdit />
            </button>
        ),
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
    }
    ];

    const customStyles = {
        headCells: {
            style: {
                backgroundColor: '#23a3e1',
                color: 'white',
                fontSize: '0.8rem',
                fontWeight: 'Bold'
            }
        },
    };
    return(
        <div className='flex flex-col justify-center w-full gap-5'>
            <div className='flex justify-between items-center'>
                <div className="flex items-center gap-2">
                    <IoArrowUndo
                        onClick={() =>
                            navigate(`/doctor-list?page=${fromPage}`)
                        }
                        className="h-8 w-8 text-secondary cursor-pointer"
                    />
                    <PageTitle icon={<BiSolidUser />} title="User Assign Role" />
                </div>
                <div className='flex justify-between items-center'>
                    <div className='flex gap-4'>
                        {/* Button to open popup for creating new user */}
                        <button
                            onClick={() => {
                                setSelectedRole(null);
                                setShowPopup(true);
                            }}
                            className="flex items-center justify-center gap-3 text-sm px-4 py-2 bg-primary text-white rounded-md">
                            Create Role
                        </button>
                    </div>
                </div>
            </div>

            <div className="flex flex-col">
                <h2 className='text-2xl font-bold text-blue-500'>{user.name}</h2>
                <p>{user.details?.education}</p>
                <p>BMDC reg no: {user.details?.bmdcRegNo}</p>
            </div>

            <div>
                <DataTable
                    columns={columns}
                    data={roles}
                    customStyles={customStyles}
                    pagination
                    highlightOnHover
                    striped
                    defaultSortFieldId="createdAt"  // Set the field to sort by initially
                    defaultSortAsc={false}
                />
            </div>
            {showPopup && (
                <div className="fixed inset-0 bg-gray-600 bg-opacity-75 flex items-center justify-center">
                    <div className="bg-white p-5 rounded-md shadow-lg">
                        <UserRoleForm
                            user={user}
                            userRole={selectedRole}
                            onClose={closePopup}
                            onAddLocation={fetchUserRole}
                            onAddLocationSuccess={handleAddLocationSuccess}/>
                    </div>
                </div>
            )}
        </div>
    )
};
export default UserDetails